import { Component, Input, OnChanges } from '@angular/core';
import * as Highcharts from 'highcharts';

@Component({
  standalone: false,
  selector: 'app-horizontal-stacked-bar-chart',
  templateUrl: './horizontal-stacked-bar-chart.component.html',
})
export class HorizontalStackedBarChartComponent implements OnChanges {
  @Input() title!: string;
  @Input() categories!: string[];
  @Input() series!: Highcharts.SeriesBarOptions[];
  @Input() width = 460;
  @Input() height = 200;

  Highcharts: typeof Highcharts = Highcharts;
  chartOptions!: Highcharts.Options;

  ngOnChanges(): void {
    if (this.categories && this.series) {
      this.initChartOptions();
    }
  }

  private initChartOptions(): void {
    this.chartOptions = {
      chart: {
        type: 'bar',
        width: this.width,
        height: this.height,
      },
      title: {
        text: this.title,
        style: {
          color: '#62bcc3',
          cursor: 'pointer',
        },
      },
      xAxis: {
        categories: this.categories,
      },
      yAxis: {
        min: 0,
        title: { text: '' },
      },
      legend: {
        reversed: true,
        itemStyle: {
          fontWeight: 'normal',
        },
      },
      plotOptions: {
        series: {
          stacking: 'normal',
          dataLabels: {
            enabled: true,
            style: {
              color: '#000',
              fontWeight: '100',
              fontSize: '12px',
              textOutline: 'none',
            },
            formatter: function () {
              return this.y && this.y !== 0 ? this.y.toString() : null;
            },
          },
        },
      },
      series: this.series,
    };
  }
}
